export default {
  en: {
    title: 'My dictionaries',
    newDictionary: 'New dictionary',
    createSubmit: 'Create',
    emptyState: "No dictionaries yet — create one and collect any words you like.",
    wordsCount_one: '{{count}} word',
    wordsCount_other: '{{count}} words',
    loadingDictionaries: 'Loading dictionaries',
  },
  ru: {
    title: 'Мои словари',
    newDictionary: 'Новый словарь',
    createSubmit: 'Создать',
    emptyState: 'Словарей пока нет — заведи свой и собирай туда любые слова.',
    wordsCount_one: '{{count}} слово',
    wordsCount_few: '{{count}} слова',
    wordsCount_many: '{{count}} слов',
    loadingDictionaries: 'Загружаю словари',
  },
};
